// eslint-disable-next-line @nx/enforce-module-boundaries
import { User } from '@ups/xplat/core';
import { IEmployeeInfo } from '@ups/xplat/api/dto';

/**
 * Maps the Software Security `User` payload to the app's `IEmployeeInfo` shape.
 *
 * Extracted verbatim from `UserService.fetchMyInfo` during the PR 3803 fix so
 * the service stays under the 500-line file-size gate. Pure and side-effect
 * free: the service owns assigning `this.myInfo`, the resolution signal, and the
 * profileUpdated event.
 *
 * Note the deliberate fan-out: `WorkPhone`, `Phone` and `CellPhone` all read
 * from `u.cellPhone` (the payload carries only the one number).
 */
/* eslint-disable @typescript-eslint/naming-convention */
export function mapUserToEmployeeInfo(u: User): IEmployeeInfo {
  const myInfo = {
    Auth0UserId: u.auth0UserId,
    UserId: u.userId,
    Data: null,
  } as IEmployeeInfo;
  myInfo.Data = {
    Email: u.email,
    FirstName: u.firstName,
    HRRef: u.hrRef,
    LastName: u.lastName,
    MiddleName: u.middleName,
    ProxyHRRef: u.proxyHRRef,
    WorkPhone: u.cellPhone,
    Phone: u.cellPhone,
    CellPhone: u.cellPhone,
    EmployeeID: u.employeeID,
    Active: u.active,
    VPCompanyID: u.vpCompanyID,
    AbsorbDateUpdated: u.absorbDateUpdated,
    FullName: u.fullName,
  };
  return myInfo;
}
/* eslint-enable @typescript-eslint/naming-convention */
